import useOfficesToDisplay from "@/utils/hooks/useOfficesToDisplay";
import PageLayout from "@components/core/layouts/PageLayout";
import CardSection from "@components/core/section/CardSection";
import BasicTabs from "@components/core/tabs/BasicTabs";
import { ROUTES } from "@routes/Routes";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import OfficeCell from "@views/core/extranet/menu/offices/office/OfficeCell";

const OfficeScreen: FunctionComponent = () => {
  const { t } = useTranslation();

  const { officesToDisplay, handleTabClick, activeKey } = useOfficesToDisplay(
    window.location.hash.split("_")[1] ?? "",
  );

  return (
    <PageLayout container returnRoute={ROUTES.extranet.home.generate()}>
      <CardSection title={t("offices.office.title")}>
        <BasicTabs
          activeKey={activeKey}
          onTabClick={handleTabClick}
          tabs={officesToDisplay.map((office) => {
            return {
              title: office.alias,
              content: <OfficeCell office={office} />,
            };
          })}
        />
      </CardSection>
    </PageLayout>
  );
};

export default OfficeScreen;
